import { makeObservable, observable, computed, action, toJS } from 'mobx';
import router from 'next/router';
import FilterState from '@features/categories/mobx/state/FilterState';
import { TFilterDetail, TFilterSelectOptions } from '@features/categories/typescript';
export default class FilterSelectState extends FilterState {
  state = '';
  options: TFilterSelectOptions = {} as TFilterSelectOptions;
  constructor(filter: TFilterDetail) {
    super(filter);
    makeObservable(this, {
      state: observable,
      queryURLString: computed,
      setValue: action,
      resetValue: action,
      value: computed,
      isSet: computed
    });

    // this.options = filter.data;

    this.state = '';
  }
  get value() {
    return toJS(this.state);
  }
  get isSet() {
    return this.state !== '';
  }
  setValue(value: string, noURLUpdate = false) {
    this.state = value;
    if (!noURLUpdate) {
      this.markUserActivity();
      this.setValueToURLString();
    }
  }
  resetValue(noURLUpdate = false) {
    this.setValue('', noURLUpdate);
  }
  setValueFromURLString() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(this.queryName);
    if (paramValue) this.state = paramValue;
  }
  setValueToURLString() {
    const {
      location
    } = window;
    const urlParams = new URLSearchParams(location.search);
    urlParams.set(this.queryName, this.value);
    router.replace(`${location.origin + location.pathname}?${decodeURIComponent(urlParams.toString())}`, undefined, {
      scroll: false,
      shallow: true
    });
  }
  get queryURLString() {
    const urlParams = new URLSearchParams();
    urlParams.append(this.queryName, this.value);
    return decodeURI(urlParams.toString());
  }
}